import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { getRemainingTime } from '@interlayer/js/custom/components/main/BingoScheduler/helpers/utilities';
import { selectBingoScheduleGames } from '@interlayer/js/custom/components/main/BingoScheduler/store/selectors';

import { ListData } from '../types';

const TIME_DIVISION = 1000;

interface Props {
    drawTime: string;
    setShouldRemoveGame: (shouldRemove: boolean) => void;
    listData: ListData;
}

const useTimer = ({ drawTime, setShouldRemoveGame, listData }: Props) => {
    const { formatTimeFromSeconds } = window.Playtech.API.formatter;

    const remainingTime = getRemainingTime(drawTime);
    const bingoScheduleGames = useSelector(selectBingoScheduleGames);

    const intervalIdRef = useRef<NodeJS.Timeout | null>(null);
    const calculatedTime = Math.floor(remainingTime / TIME_DIVISION);

    const [time, setTime] = useState({
        timer: remainingTime >= 0 ? calculatedTime : 0,
        renderedView: remainingTime >= 0
            ? formatTimeFromSeconds(calculatedTime)
            : formatTimeFromSeconds(0)
    });

    useEffect(() => {
        intervalIdRef.current = setInterval(() => {
            setTime((prevTime) => {
                const updatedTime = prevTime.timer - 1;

                return {
                    timer: updatedTime >= 0 ? updatedTime : 0,
                    renderedView: updatedTime >= 0
                        ? formatTimeFromSeconds(updatedTime)
                        : formatTimeFromSeconds(0)
                };
            });
        }, 1000);

        return () => {
            intervalIdRef.current && clearInterval(intervalIdRef.current);
        };
    }, [bingoScheduleGames, formatTimeFromSeconds]);

    useEffect(() => {
        if (time.timer === 0) {
            const { isLastView, bingoListRef, setCurrentPosition } = listData;

            if (isLastView && bingoListRef.current && setCurrentPosition) {
                const { scrollWidth, clientWidth } = bingoListRef.current;

                setCurrentPosition(scrollWidth - clientWidth);
            }

            setShouldRemoveGame(true);
            clearInterval(intervalIdRef.current as NodeJS.Timeout);
        }
        /* @TODO: check it */
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [time.timer]);

    return time;
};

export default useTimer;
